/** Auth shell constants (WP-RD-9). Copy lives in the i18n `auth` namespace. */

export const OAUTH_PROVIDERS = ["google", "microsoft"] as const;
export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number];

/**
 * Providers the product offers. Microsoft stays a visible, disabled "Not configured yet" button (DEC-005, D13 of the redesign plan):
 * flip it to true when the Microsoft app registration is live. No provider is probed on page load: the start endpoint answers a 404
 * while a provider is off, and the browser logs that as a console error on every sign-in page view. Google is checked when it is clicked.
 */
export const OAUTH_PROVIDER_LIVE: Readonly<Record<OAuthProvider, boolean>> = { google: true, microsoft: false };

/** Card widths of the shell (px, mirrored by auth.css `.a-card[data-width]`). */
export const AUTH_CARD_WIDTH = { sm: 520, md: 600 } as const;

/** Placeholder on every work-email field of the shell (the mockup's). */
export const WORK_EMAIL_PLACEHOLDER = "you@yourorganization.ph";

/** Seconds in a minute, for the Retry-After to minutes conversion of the reset-link throttle message. */
export const SECONDS_PER_MINUTE = 60;
